import React from 'react';

import {
  ButtonShape,
  ButtonSize,
  ButtonVariant,
  StyledButton,
} from './styles';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Formato do botão: `default` (raio do size) ou `pill` (totalmente arredondado) */
  shape?: ButtonShape;
  fullWidth?: boolean;
  color?: string;
  backgroundColor?: string;
};

const Button = ({
  variant = 'primary',
  size = 'md',
  shape = 'default',
  fullWidth = false,
  color,
  backgroundColor,
  type = 'button',
  children,
  ...rest
}: ButtonProps): JSX.Element => {
  return (
    <StyledButton
      type={type}
      $variant={variant}
      $size={size}
      $shape={shape}
      $fullWidth={fullWidth}
      $color={color}
      $backgroundColor={backgroundColor}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
